const riot = require('riot');

riot.tag2('page-auth', '<div class="f fh fclm s-full"> <form class="f fclm w320 mb16" onsubmit="{onSubmit}"><img class="w220 object-fit-contain mxa mb48" src="/images/logo.svg"> <input class="input mb24" if="{(!isSignInWithEmailLink() || !email)}" ref="email" placeholder="メールアドレス" required type="email"> <button class="button primary">{isSignInWithEmailLink() ? ⁗ログイン⁗ : ⁗送信⁗}</button> </form> </div>', 'page-auth,[data-is="page-auth"]{display:block}', '', function(opts) {
    this.head = () => {
      return {
        title: 'ログイン | Repro Incentive',
      };
    };

    this.on('show', () => {
      this.email = localStorage.getItem("emailForSignIn");
      this.update();
    });

    this.onSubmit = async (e) => {
      e.preventDefault();
      var indicator = spat.modal.indicator();

      if (this.isSignInWithEmailLink()) {

        try {
          if (!this.email) {
            this.email = this.refs.email.value;
          }
          await app.auth.signInWithEmailLink(this.email, location.href);
          await app.api.child('me/sign_in');
          spat.modal.alert('ログインが完了しました');
          localStorage.removeItem("emailForSignIn");
          this.email = '';
          this.update();
        }
        catch (e) {
          console.error(e);
          spat.modal.alert(e.message);
        }
        finally {
          indicator.close();
        }
      }

      else {
        try {
          var email = this.refs.email.value;
          var providers = await app.auth.fetchSignInMethodsForEmail(email);

          if (0 < providers.length) {

            const actionCodeSettings = {
              url: `${spat.config.domain}/signin`,
              handleCodeInApp: true,
            };

            await app.auth.sendSignInLinkToEmail(email, actionCodeSettings);
            localStorage.setItem('emailForSignIn', email);
            spat.modal.alert('メールを送信しました')
          }

          else {
            spat.modal.alert('未登録のユーザーです');
          }
          this.refs.email.value = '';
        }
        catch (e) {
          console.error(e);
          spat.modal.alert(e.message);
        }
        finally {
          indicator.close();
        }
      }
    };

    this.isSignInWithEmailLink = () => {
      return app.auth.isSignInWithEmailLink(location.href);
    };
});